// Muestra una fecha AAAA-MM-DD (o AAAA-MM-DDThh:mm…) como dd/mm/aaaa.
// Cualquier otro valor se devuelve tal cual.
export function fechaDMA(valor) {
  const m = String(valor ?? '').match(/^(\d{4})-(\d{2})-(\d{2})(?:$|T)/);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : valor;
}
